/**
 * `core` 内部の小道具。外部レイヤからは使わない。
 */

/**
 * 添字アクセスの結果を `undefined` を含まない型で受け取る。
 *
 * `noUncheckedIndexedAccess` の下では `xs[i]` が `T | undefined` になる。範囲内であることが
 * 呼び出し側の不変条件から明らかな箇所でこの分岐を毎回書くと、本物の異常系が埋もれる。
 * ここに 1 か所だけ集約し、破れていれば黙って進まずに落とす。
 */
export function at<T>(xs: ArrayLike<T | undefined>, i: number): T {
  const value = xs[i];
  // 到達しない枝。到達したら呼び出し側の添字計算が壊れている。
  /* v8 ignore next */
  if (value === undefined)
    throw new Error(`内部エラー: 添字 ${i} が範囲外です（長さ ${xs.length}）。`);
  return value;
}
